import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { Logo } from './Logo';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-emerald-950 text-emerald-50 pt-20 pb-10 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://assets.auxodev.dk/assets/8a41795c-dcbb-4ba1-a6ae-e2582bf01d41/image00010.jpeg" 
          alt="" 
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-emerald-950/80" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="space-y-6">
            <Logo light className="h-10" />
            <p className="text-emerald-200/80 leading-relaxed max-w-xs">
              Professionel ejendomsservice og havearbejde med fokus på kvalitet, stabilitet og personlig kontakt.
            </p>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-emerald-900 flex items-center justify-center border border-emerald-800">
                <span className="text-red-500 font-bold">DK</span>
              </div>
              <span className="text-sm text-emerald-300">CVR: 46182588</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Hurtige links</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/ejendomsservice" className="text-emerald-200/70 hover:text-white transition-colors flex items-center gap-2 group">
                  <ArrowRight className="w-4 h-4 text-emerald-600 group-hover:translate-x-1 transition-transform" />
                  Ejendomsservice
                </Link>
              </li>
              <li>
                <Link to="/andre-opgaver/graesslaaning" className="text-emerald-200/70 hover:text-white transition-colors flex items-center gap-2 group">
                  <ArrowRight className="w-4 h-4 text-emerald-600 group-hover:translate-x-1 transition-transform" />
                  Græsslåning
                </Link>
              </li>
              <li>
                <Link to="/andre-opgaver/flishugning" className="text-emerald-200/70 hover:text-white transition-colors flex items-center gap-2 group">
                  <ArrowRight className="w-4 h-4 text-emerald-600 group-hover:translate-x-1 transition-transform" />
                  Flishugning
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="text-emerald-200/70 hover:text-white transition-colors flex items-center gap-2 group">
                  <ArrowRight className="w-4 h-4 text-emerald-600 group-hover:translate-x-1 transition-transform" />
                  Galleri
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Kontakt os</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:+4542442359" className="text-emerald-200/70 hover:text-white transition-colors flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-emerald-900 flex items-center justify-center">
                    <Phone className="w-4 h-4 text-red-500" />
                  </div>
                  42 44 23 59
                </a>
              </li>
              <li>
                <a href="mailto:Djensen2@me.com" className="text-emerald-200/70 hover:text-white transition-colors flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-emerald-900 flex items-center justify-center">
                    <Mail className="w-4 h-4 text-red-500" />
                  </div>
                  Djensen2@me.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-emerald-200/70">
                <div className="w-8 h-8 rounded-lg bg-emerald-900 flex items-center justify-center">
                  <MapPin className="w-4 h-4 text-red-500" />
                </div>
                Dækker hele lokalområdet
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div className="bg-emerald-900/50 p-6 rounded-2xl border border-emerald-800">
            <h4 className="text-white font-bold mb-3">Skal vi hjælpe dig?</h4>
            <p className="text-emerald-200/70 text-sm mb-6">
              Kontakt os i dag for et uforpligtende tilbud på din opgave.
            </p>
            <Link
              to="/kontakt"
              className="block text-center bg-emerald-600 text-white py-3 rounded-xl font-semibold hover:bg-emerald-500 transition-colors shadow-lg"
            >
              Få et tilbud
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-emerald-900 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-emerald-400">
          <p>© {currentYear} DK Grøn Service. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-6">
            <span>CVR: 46182588</span>
            <div className="flex items-center gap-1">
              Designet med <span className="text-red-500">❤️</span> i Danmark
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
